import React from 'react';


function Shareholders() {
  return (<>
    <div>Shareholders</div>
    <p>Reports: Captable Summary & Detail, Secondary Transactions, Vesting Report</p>
    <p>Certificate Templates, Board Resolutions, Certificates, Agreements (safe and others, product creation)</p>
   

    </>)
}

export default Shareholders